<div class="pageContainer refreshed-ui">
    <div class="spd-wrapper">
        <div class="sp-breadcrumb-nav-bar">
            <a data-id="solution-participation-details" routerLink="/solution-participation-details" [queryParams]="{tab: 'solution-group-view'}" class="link-blue">
                Solution Participation - Solution Group View
            </a>
            <div class="chevron"><img src="assets/chevron-right.svg" alt="chevron-right" /></div>
            <a data-id="solution-participation-groupBy" [routerLink]="['/solution-participation-groupBy']" [queryParams]="{ groupBy: 'location', solutionGroup: solutionGroupName }"class="link-blue">
                Location Details
            </a>
            <div class="chevron"><img src="assets/chevron-right.svg" alt="chevron-right" /></div>
            <a data-id="solution-participation-location-drilldown " class="last-breadcrumb link-blue">
                {{siteName! | capitalize}}
            </a>
        </div>

        <div class="exporttable-block">
            <div class="exporttable-btn" (click)="exportAllToExcel()">
                <div class="export-icon">
                 <span *ngIf="!isDownloadingFile">
                    <img src="assets/export-table-icon.svg" alt="export-table-icon" />
                </span>
                <span *ngIf="isDownloadingFile">
                    <span class="loader-sm"></span>
                </span>
                </div>
                <span>Export Table</span>
            </div>
        </div>
        <div class="search-pagination-row">
            <div id="sol-loc-toggle-pagination" class="sol-loc-toggle-pagination">
                <mat-paginator #paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 20, 50]" [length]="totalRows"
                (page)="onPageChange($event)" aria-label="Select page"></mat-paginator>
            </div>
        </div>

        <section class="location-details-table" id="locations-details-table" *ngIf="!isLoading; else loader">

            <!-- Table header section -->
            <div class="header-box">
                <div class="location common-p">
                    Location
                </div>
                <div class="accountNumber common-p">Account Number</div>
                <div class="product common-p">Product</div>
                <div class="sales common-p">
                    Product Sales Summary
                    <span class="sort-arrow" data-id="sort-arrow-sales" (click)="toggleSortDirection('sales')">
                        <img class="sort-arrow-img" [ngClass]="{'up': sortDirections['sales'] == 'asc', 'down': sortDirections['sales'] == 'desc' }" src="assets/blue-arrow.svg" alt="sort-arrow" />
                    </span>
                </div>
                <div class="cases common-p">
                    Cases
                    <span class="sort-arrow" data-id="sort-arrow-cases"  (click)="toggleSortDirection('cases')">
                        <img class="sort-arrow-img" [ngClass]="{'up': sortDirections['cases'] == 'asc', 'down': sortDirections['cases'] == 'desc' }" src="assets/blue-arrow.svg" alt="sort-arrow" />
                    </span>
                </div>
                <div class="exportall-checkbox common-p">
                    <mat-checkbox color="primary" (change)="selectAllRows()" [checked]="allRowsSelected">Export All</mat-checkbox>
                </div>
            </div>

            <ng-container *ngIf="locationsData.length; else noData">
                <ng-container *ngFor="let location of locationDataPaginated; let i = index">
                    <div class="locations-table-row" [id]="'location-table-row-' + i">
                        <!-- Location block -->
                        <div class="location-block p-20">
                            <div class="text-700">{{location?.mdmSiteId}} - {{location?.siteName! | capitalize}},</div>
                            <div >{{location?.address}},</div>
                            <div>
                                <span>{{location?.city! | capitalize}},</span>
                                <ng-container *ngIf="location?.state">
                                    {{location?.state}},
                                </ng-container>
                            </div>
                            <div>{{location?.country}} - {{location?.postalAddress}}</div>
                        </div>

                        <div class="account-block p-20">
                            {{ location.accountNumber}}
                        </div>
                        <div class="product-block p-20">
                            <p class="product-name">{{ location.productName}}</p>
                            <p class="product-code">SKU - {{ location.productCode}}</p>
                        </div>
                        <div class="sales-block p-20">
                            <p class="sales-amount">{{currencyCode | currencySymbol}}{{ location.siteSalesAmount | number:'1.0-0' }}</p>
                        </div>
                        <div class="cases-block p-20">
                            <p class="cases-amount">{{ location.siteSalesQty | number}}</p>
                        </div>
                        <div class="export-block p-20">
                            <div class="export-checkbox">
                                <mat-checkbox  color="primary" class="checkbox" [checked]="rowSelection[(paginator.pageIndex * paginator.pageSize) + i]"
                                #checkBox (change)="onCheckboxChange(checkBox,location,i)">Export</mat-checkbox>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </ng-container>

            <!-- Display 'No Data' when there are no locations on load -->
            <ng-template #noData>
                <div class="Loader">
                    No Data
                </div>
            </ng-template>

            <!-- Display 'Location not found' when search results are empty -->
            <ng-template [ngIf]="filteredData.length == 0">
                <div class="not-found">
                    Location not found.
                </div>
            </ng-template>
        </section>

        <ng-template #loader>
            <div class="Loader">
                Loading...
                <loader></loader>
            </div>
        </ng-template>
    </div>
</div>
